<template>
    <textarea v-model="currentValue" @input="onInput" :rows="rows" :placeholder="placeholder"
        ref="textinput"></textarea>
</template>

<script>
export default {
    name: "TextareaAutoExpand",
    inheritAttrs: false,
    props: {
        value: {
            type: [String, null],
            default: "",
        },
        rows: {
            type: [Number, String],
            default: 3,
        },
        placeholder: {
            type: String,
            default: "",
        },
        maxHeight: {
            type: [Number, String],
            default: 400
        },
    },
    data() {
        return {
            currentValue: this.value,
        }
    },
    watch: {
        value(newValue) {
            // Expand the input when the value changes in the parent.
            if (newValue !== this.currentValue) {
                this.currentValue = newValue
                this.autoExpandInput()
            }
        },
    },
    methods: {
        onInput(e) {
            this.$emit("input", e.target.value)
            this.autoExpandInput()
        },
        autoExpandInput() {
            this.$nextTick(() => {
                let input = this.$refs.textinput
                // If the current height is larger than height of the contents, do nothing. The
                // user might have manually expanded the height of the textarea, so we don't
                // want to shrink the textarea back down.
                if (input.offsetHeight > input.scrollHeight) {
                    return
                }
                // Reset the height to shrink back if text is deleted.
                input.style.height = "auto"
                // Set the height to the scrollHeight to remove the scrollbar, up to a max height.
                let calculatedHeight = Math.min(this.maxHeight, input.scrollHeight)
                // Don't set the height of the textarea to less than a height of around 2
                // rows, for now.
                if (calculatedHeight > 52) {
                    input.style.height = calculatedHeight + "px"
                }
            })
        },
    },
    mounted() {
        // This is a hack that seems to fix an issue where the initial height
        // of the input is set to a very small value. Delaying the initial auto-expand
        // seems to fix this.
        window.setTimeout(() => {
            this.autoExpandInput()
        }, 50)
    },
}
</script>

<style lang="scss" scoped></style>
